import React from 'react';
import styled from 'styled-components';
import ChatBotLauncher from './launcher';
import { sleep } from './util';
import { animated, useSpring } from 'react-spring';

const ChatBotLauncherContainer = styled.div`
  background: transparent;
`;

interface IProps {
  toggleChatbot: any;
  toggle: boolean;
  setToggle: (toggle: boolean) => void;
  start: boolean;
  loading: boolean;
  toggleCloseDialog: any;
}

const ChatBotOpenFrame: React.FC<IProps> = ({
  toggleChatbot,
  toggle,
  setToggle,
  loading,
  toggleCloseDialog,
  start
}) => {
  const chatBotLauncherAnim = useSpring({
    from: {
      opacity: toggle ? 1 : 0,
      left: toggle ? '0' : '120px',
      height: toggle ? '100%' : '0px'
    },
    to: async (next: any, cancel: any) => {
      await next({
        opacity: toggle ? 0 : 1,
        left: toggle ? '120px' : '0px',
        height: toggle ? '100%' : '0px'
      });
    },
    delay: 0
  });

  const showChatBot = async () => {
    // const sample = document.getElementById('chatbot-btn');
    // if (sample !== null) {
    //   sample.style.height = '1200px';
    // }
    setToggle(!toggle);
    await sleep(600);
    toggleChatbot(start);
    // await sleep(200);
  };

  return (
    <animated.div
      style={{
        ...chatBotLauncherAnim,
        position: 'relative',
        bottom: '0',
        right: '0'
      }}
    >
      {loading === false && (
        <ChatBotLauncherContainer id="chatbot-launcher">
          <ChatBotLauncher
            showChatBot={showChatBot}
            toggleCloseDialog={toggleCloseDialog}
          />
        </ChatBotLauncherContainer>
      )}
    </animated.div>
  );
};

export default ChatBotOpenFrame;
